import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { axiosSettings } from "../../axios/axios";
import {
  UserInfoState,
  UserInfoParams,
  UserInfoApiResponse,
  UserInfoSearchData,
} from "./UserInfoType";
import { RootState } from "../../redux/store";
import { GetTime } from "../../utils/timeget";

//情報取得API連携
export const fetchAsyncUserInfo: any = createAsyncThunk<
  UserInfoApiResponse & { page: number },
  UserInfoParams
>("UserInfo/get", async (page) => {
  const response = await axiosSettings.get(`api-admin/user?page=${page}`);
  return { ...response.data, page };
});
export const fetchAsyncSearchUsers = createAsyncThunk<
  UserInfoSearchData,
  UserInfoParams
>("UserInfoSearch/get", async ({ page, option, word }: UserInfoParams) => {
  let url = `api-admin/user?page=${page}`;
  let postData = {};
  if (option && word) {
    if (option === "メールアドレス") {
      postData = { email: word };
    } else if (option === "電話番号") {
      postData = { number: word };
    } else if (option === "生年月日") {
      postData = { birthday: word };
    } else if (option === "ユーザNo.") {
      postData = { user_id: word };
    } else if (option === "氏名") {
      postData = { name: word };
    }
    url += `&option=${option}&word=${encodeURIComponent(word)}`;
  }
  const response = await axiosSettings.get(url, { params: postData });
  return response.data;
});

const initialState: UserInfoState = {
  initialUserInfo: null,
  otherUserInfo: null,
  updatedTime: "",
  loading: false,
  error: "",
  searchUserInfo: null,
};

const UserInfoSlice = createSlice({
  name: "UserInfo",
  initialState: initialState,
  reducers: {
    resetSearch(state) {
      state.searchUserInfo = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchAsyncUserInfo.fulfilled, (state, action) => {
      //トークン認証&通信成功、データを受け取る
      const { page, data, status } = action.payload;
      //1ページ目だけ保持、その他は都度更新
      if (status === "Success") {
        if (page === 1) {
          state.initialUserInfo = Array.isArray(data.result.data)
            ? data.result.data
            : [];
          state.updatedTime = GetTime();
          state.error = "";
        } else {
          state.otherUserInfo = Array.isArray(data.result.data)
            ? data.result.data
            : [];
        }
      } else {
        state.error = data;
      }
      state.loading = false;
    });
    builder.addCase(fetchAsyncSearchUsers.fulfilled, (state, action) => {
      state.searchUserInfo = action.payload;
    });
    builder.addCase(fetchAsyncUserInfo.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(fetchAsyncSearchUsers.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "";
    });

    // builder.addCase(fetchAsyncUserInfo.rejected, (state, action) => {
    //   state.loading = false;
    //   state.error = action.payload.data;
    // });
  },
});

export const selectSearchUserInfo = (state: RootState) =>
  state.UserInfo.searchUserInfo;
export const selectInitialUserInfo = (state: RootState) =>
  state.UserInfo.initialUserInfo;
export const selectOtherUserInfo = (state: RootState) =>
  state.UserInfo.otherUserInfo;
export const userInfoError = (state: RootState) => state.UserInfo.error;
export const userInfoLoading = (state: RootState) => state.UserInfo.loading;
export const userInfoUpdatedTime = (state: RootState) =>
  state.UserInfo.updatedTime;
export const { resetSearch } = UserInfoSlice.actions;
export default UserInfoSlice.reducer;
